export default __webpack_public_path__ + "static/media/financas3.a89a4dfa.jpg";